import { Component, OnInit, Input, SimpleChanges, OnChanges} from '@angular/core';
import * as Highcharts from 'highcharts';
import Exporting from "highcharts/modules/exporting";
import { chartDatas} from 'src/assets/i18n/hi.json';
import * as XLSX from 'xlsx';
Exporting(Highcharts);

@Component({
  selector: 'app-bar-bubble-chart',
  templateUrl: './bar-bubble-chart.component.html',
  styleUrls: ['./bar-bubble-chart.component.css']
})
export class BarBubbleChartComponent implements OnInit, OnChanges {

   @Input() barchartData: object;
   @Input() chartId;
   @Input() selectedlanguage:string;
   barChart = Highcharts;
   scatterChart = Highcharts;
   chartOptions = {};
   context;
   @Input() yAxisPlot: any=[];
   chart: any;

   constructor() {}

   ngOnInit() {
      this.createBarChart();
      console.log('barchartdataaaaa',this.barchartData);
   }

   ngOnChanges(changes: SimpleChanges): void {
    this.createBarChart();
    }

   createBarChart(): any {
      this.chartOptions = {
        exporting : {
          enabled: true,
          buttons: {
            customButton: {
              text: 'Export to Excel',
              onclick: () => this.exportToExcel(this.barchartData['seriesdata'][0]['data'])
            },
          }
       },
        chart: {
          type: 'bar',
          marginTop: 70,
          height : this.calculateChartHeight(this.barchartData['seriesdata'])
      },
        title: {
          text: this.barchartData['title'],
          align: 'left',
          style : {
            fontWeight: 'bold'
          }
      },
      xAxis:{
         categories: this.yAxisPlot, 
         title: {
           text: null
         },
         labels : {
          style: {
            color: 'black',
            fontSize: '14px'
          }
         }
       },
       colors: ['#7ec0e0', 'black'],
        yAxis : [
          {
            title: {
              text: this.selectedlanguage=='en'?'Change in score':chartDatas['Change in score'],
              style : {
                color : 'black',
                fontSize : '15px'
              }
            },
            labels: {
              style: {
                color: 'black',
                fontSize: '14px'
              }
            },
            width: '50%',
            showLastLabel: false
          },
          {
            title: {
              // text: this.selectedlanguage=='en'? 'Base year (FY ' + this.barchartData['baseyear'] + ') and FY ' + this.barchartData['curyear'] + ' scores' : 'आधार वर्ष (वित्तीय वर्ष ' + this.barchartData['baseyear'] + ') और वित्तीय वर्ष ' + this.barchartData['curyear'] + ' स्कोर' 
              text: this.selectedlanguage=='en'? 'FY ' + this.barchartData['curyear'] + ' scores' : 'वित्तीय वर्ष ' + this.barchartData['curyear'] + ' स्कोर' ,
              style: {
                color: 'black',
                fontSize: '13px'
              }
            },
            left: '50%',
            width: '50%',
            offset: 0
            // showLastLabel: false
          }
        ],
      tooltip: {
         //  pointFormat: '{series.name}: <b>{point.y}</b>'
         // valueSuffix: ' hundreds'
         valueDecimals: 2
      },
      legend : {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          floating: true,
          y: 30,
          borderWidth: 1,
        
        //  backgroundColor: (
        //     (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || 
        //       '#FFFFFF'), 
          shadow: true
        },   
      plotOptions : {
        bar: {
          dataLabels: {
              enabled: true
          },
          pointPadding : 1.5
        },
        series: {
          pointWidth: 25
        }
      },
      credits:{
         enabled: false
      },
      series: this.barchartData['seriesdata']
    };

    setTimeout(() => {

      if(this.chart){
        this.chart.destroy();
      }

      this.chart = this.barChart.chart(this.chartId, this.chartOptions)

    }, 0)
  }

  exportToExcel(chartData): void {
    const exportData = chartData.map(item => ({ name: item.name, score: item.y }));
    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    // Add a worksheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, this.barchartData['title']);
    // Generate an Excel file and save it
    XLSX.writeFile(workbook, this.barchartData['title'] + '.xlsx');
  }

  calculateChartHeight(chartdata) {    
    const dataLength = chartdata[0].data.length;
    const baseHeight = 200;
    const minHeight = 100;
    const scalingFactor = 25; // Set the scaling factor for adjusting the height;

    // Calculate the ideal height based on the number of data points
    let idealHeight = baseHeight + dataLength * scalingFactor;

    // Ensure the height is not less than the minimum height
    idealHeight = Math.max(idealHeight, minHeight);
    // console.log("heightt",dataLength, baseHeight, minHeight, idealHeight);
    return idealHeight;
  }
}